import json from '~/../package.json'

export default {
    gtm: '',
    ga: 'UA-54771740-4',

    appTitle: 'Web',
    appName: 'Gkiokan.NET',
    version: json.version,

    showMenuButton: true,
    showDarwer: true,

    api: {
        login: '/auth/login',
        register: '/auth/register',
    }
}
